export default __webpack_public_path__ + "static/media/M27.cd1f34c3.svg";